import React from 'react';
import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";

/**
 * This component will render App Loader
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AppLoader = (props) => {
    return (
        <Box className="loader">
            <Loader type={"circular"}/>
        </Box>
    );
}

export default AppLoader;


// WEBPACK FOOTER //
// ./src/component/common/appLoader.js